/* FREUDEBOX Bild-Plus v1.2 — keine Abhängigkeiten, kein Tracking. */
(() => {
  'use strict';
  if (customElements.get('fb-image-hotspots')) return;
  class ImageHotspots extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      try { this.config = JSON.parse(this.querySelector('script').textContent); }
      catch (_) { return; }
      this.abort = new AbortController();
      this.buttons = new Map();
      this.createDialog();
      this.scan();
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.scan(); });
      });
      this.observer.observe(document.body, {childList:true, subtree:true});
    }
    scan() {
      const c = this.config;
      for (const [button] of this.buttons) if (!button.isConnected) this.buttons.delete(button);
      const galleries = document.querySelectorAll('[data-product-images]');
      for (const media of c.media) {
        if (media.type !== 'image') continue;
        const alt = (media.alt || '').toLowerCase();
        // Rubbelbilder gehören ausschließlich zum vorhandenen Slider.
        if (alt.includes('[rubbel]')) continue;
        const kind = alt.includes('[groesse]') ? 'size' : alt.includes('[verpackung]') ? 'pack' : null;
        if (!kind) continue;
        for (const gallery of galleries) {
          // Ausschließlich die Hauptgalerie dieses Produkts; keine Empfehlungen/Quickviews.
          if (gallery.closest('.modal, .quick-product__content, [data-section-type="featured-product"]')) continue;
          const productRoot = gallery.closest('[data-product-id]');
          if (!productRoot || productRoot.dataset.productId !== String(c.productId) || productRoot.dataset.history !== 'true') continue;
          const host = gallery.querySelector('.product-main-slide[data-index="' + media.index + '"] [data-product-image-main] > .image-wrap');
          if (!host || host.querySelector('.fb-hotspot')) continue;
          host.classList.add('fb-hotspot-host');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fb-hotspot';
          button.setAttribute('aria-label', kind === 'size' ? 'Größe der Kuscheltiere ansehen' : 'Mehr zur Geschenkverpackung');
          button.setAttribute('aria-haspopup', 'dialog');
          button.style.setProperty('--fb-hotspot-color', c.color);
          button.style.setProperty('--fb-hotspot-x', (kind === 'pack' ? (c.packX ?? 85) : c.x) + '%');
          button.style.setProperty('--fb-hotspot-y', (kind === 'pack' ? (c.packY ?? 21) : c.y) + '%');
          button.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 3v14M3 10h14"/></svg>';
          // Flickity darf diesen Touch nicht als Galerie-Drag übernehmen.
          for (const name of ['pointerdown','mousedown','touchstart','keydown','keyup']) {
            button.addEventListener(name, e => e.stopPropagation(), {signal:this.abort.signal,passive:true});
          }
          button.addEventListener('click', e => {
            e.preventDefault(); e.stopPropagation(); this.open(kind, media, button);
          }, {signal:this.abort.signal});
          host.appendChild(button);
          this.buttons.set(button, host);
        }
      }
    }
    createDialog() {
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'fb-hotspot-dialog';
      // Native dialog handles Escape, focus confinement and inert background.
      const id = 'fb-hotspot-title-' + Math.random().toString(36).slice(2);
      this.dialog.setAttribute('aria-labelledby', id);
      this.dialog.innerHTML = '<div class="fb-hotspot-dialog__header"><button type="button" class="fb-hotspot-dialog__close" aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"/></svg></button><h2 class="fb-hotspot-dialog__title"></h2></div><div class="fb-hotspot-dialog__tabs" role="tablist" aria-label="Informationen zur FREUDEBOX"><button type="button" role="tab" data-tab="video">So kommt sie an</button><button type="button" role="tab" data-tab="photo">Boxgröße</button></div><div class="fb-hotspot-dialog__panel" data-panel="photo" role="tabpanel"><img class="fb-hotspot-dialog__photo" alt=""><div class="fb-hotspot-dialog__body"><strong class="fb-hotspot-dialog__caption"></strong><p></p></div></div><div class="fb-hotspot-dialog__panel" data-panel="video" role="tabpanel" hidden><p class="fb-hotspot-dialog__example">Beispielbox</p><video class="fb-hotspot-dialog__video" muted controls playsinline preload="none" aria-label="So kommt deine FREUDEBOX an"></video><div class="fb-hotspot-dialog__body"><strong>So kommt deine FREUDEBOX an</strong><p>Das Video zeigt eine Beispielbox. Deine FREUDEBOX wird mit deiner Auswahl und deiner persönlichen Nachricht zusammengestellt.</p><a class="fb-hotspot-dialog__video-link" target="_blank" rel="noopener">Video separat öffnen</a></div></div>';
      this.dialog.querySelector('h2').id = id;
      this.dialog.style.setProperty('--fb-hotspot-color', this.config.color);
      this.video = this.dialog.querySelector('video');
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.appendChild(document.createElement('source'));
      const tabs = [...this.dialog.querySelectorAll('[role="tab"]')];
      for (const tab of tabs) {
        const key = tab.dataset.tab;
        tab.id = id + '-tab-' + key;
        tab.setAttribute('aria-controls', id + '-panel-' + key);
        const panel = this.dialog.querySelector('[data-panel="' + key + '"]');
        panel.id = id + '-panel-' + key;
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => this.selectTab(key), {signal:this.abort.signal});
        tab.addEventListener('keydown', e => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          const next = e.key === 'Home' ? tabs[0] : e.key === 'End' ? tabs[1] : tabs[1 - tabs.indexOf(tab)];
          this.selectTab(next.dataset.tab); next.focus();
        }, {signal:this.abort.signal});
      }
      document.body.appendChild(this.dialog);
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close(), {signal:this.abort.signal});
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      }, {signal:this.abort.signal});
      this.dialog.addEventListener('close', () => {
        this.video.pause();
        if (this.savedOverflow !== undefined) document.body.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
        if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      }, {signal:this.abort.signal});
    }
    selectTab(key) {
      this.video.pause();
      for (const tab of this.dialog.querySelectorAll('[role="tab"]')) {
        const selected = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      }
      for (const panel of this.dialog.querySelectorAll('[data-panel]')) panel.hidden = panel.dataset.panel !== key;
      if (key === 'video' && !this.video.querySelector('source').hasAttribute('src')) {
        const source = this.video.querySelector('source');
        source.src = this.videoUrl;
        source.type = 'video/mp4';
        this.video.load();
      }
    }
    open(kind, media, trigger) {
      if (this.dialog.open) return;
      const size = kind === 'size';
      const customPhoto = size ? this.config.sizePhoto : this.config.packPhoto;
      const photo = this.dialog.querySelector('img');
      photo.src = customPhoto || media.image;
      photo.alt = size ? (customPhoto ? 'Größenvergleich der Kuscheltiere' : 'Auswahl der Kuscheltiere') : (customPhoto ? 'Größenbeispiel: FREUDEBOX in den Händen' : 'Geschenkverpackung der FREUDEBOX');
      // Ohne eigenes Vergleichsfoto erscheint das markierte Produktbild als Vorschau.
      this.dialog.querySelector('h2').textContent = size ? 'Wie groß ist dein Kuscheltier?' : 'So kommt deine Box an';
      this.dialog.querySelector('.fb-hotspot-dialog__caption').textContent = size ? 'Je nach Modell ca. 22–28 cm' : 'So liegt die Box in den Händen';
      this.dialog.querySelector('[data-panel="photo"] p').textContent = size
        ? 'Die genaue Größe hängt von deinem ausgewählten Kuscheltier ab.'
        : 'Größenbeispiel zur Orientierung. Die Boxgröße passen wir dem Inhalt deiner Bestellung an.';
      this.videoUrl = this.config.packVideo || 'https://cdn.shopify.com/videos/c/o/v/bfcbc39add34432c8a57a57a5e56dbe9.mp4';
      this.dialog.querySelector('.fb-hotspot-dialog__video-link').href = this.videoUrl;
      this.dialog.querySelector('[role="tablist"]').hidden = size;
      this.video.muted = true;
      this.selectTab(size ? 'photo' : 'video');
      this.trigger = trigger;
      this.savedOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.savedOverflow !== undefined) document.body.style.overflow = this.savedOverflow;
      this.video?.pause();
      this.video?.querySelector('source')?.removeAttribute('src');
      this.abort?.abort();
      this.dialog?.remove();
      for (const [button, host] of this.buttons || []) { button.remove(); host.classList.remove('fb-hotspot-host'); }
      this.abort = null;
    }
  }
  customElements.define('fb-image-hotspots', ImageHotspots);
})();
